<template>
  <div class="container-list">
    <div class="common-page common-head">
      <div class="common-page common-head-title">
        <i class="icon-tr-other" style="padding-right: 5px"></i>
        新增巡查点
      </div>
    </div>
    <!-- <unitList @select="getUnit" @getFirst='getOne'></unitList> -->
    <el-form ref="form" :model="form" label-width="80px" :rules="rules" class="mt20">
      <div class="f-right border-b">
        <div class="flex1">基本信息</div>
      </div>
      <el-row :gutter="20">
        <el-col :span="15">
          <el-row>
            <el-form-item
              prop="areaId"
              label-width="160px"
              label="所属区域(部门)"
              :rules="{
                message: '请填写/选择',
                trigger: 'blur',
                required: true,
              }"
            >
              <!-- <el-input v-model="form.patrol.c_point_area"></el-input>
               -->

              <el-select v-model="form.areaId">
                <el-option
                  v-for="(item, index) in areaList"
                  :label="item.x_company_area"
                  :value="item.x_company_id"
                  :key="index"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item
              label-width="160px"
              prop="pointNum"
              label="巡查点编号"
              :rules="{
                message: '请填写/选择',
                trigger: 'blur',
                required: true,
              }"
            >
              <el-input v-model="form.pointNum"></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label-width="160px" prop="pointName" label="巡查点名称">
              <el-input v-model="form.pointName"></el-input>
            </el-form-item>
            <el-form-item label-width="160px" prop="pointAddr" label="巡查点位置">
              <el-input v-model="form.pointAddr"></el-input>
            </el-form-item>
            <el-form-item label-width="160px" prop="pointBasic" label="巡查点设备">
              <el-input v-model="form.pointBasic"></el-input>
            </el-form-item>
            <el-form-item label-width="160px" prop="nfcNum" label="NFC编号">
              <el-input v-model="form.nfcNum"></el-input>
            </el-form-item>
            <el-form-item label-width="160px" prop="builderName" label="文物建筑名称">
              <el-input v-model="form.builderName"></el-input>
            </el-form-item>
            <el-form-item label-width="160px" prop="nfcNum" label="路名门牌">
              <el-input v-model="form.roadNameDoorplate"></el-input>
            </el-form-item>
          </el-row>
        </el-col>
        <!-- <el-col :span="12">
          <el-row>
            <el-form-item label-width="160px" prop="" label="巡查频次设置 ">
              <el-switch v-model="form.isTime"> </el-switch>
              &nbsp;
              <el-button
                type="primary"
                size="mini"
                icon="el-icon-plus"
                @click="addtime"
              ></el-button>
            </el-form-item>
          </el-row>
          <div
            v-show="form.isTime"
            v-for="(item, index) in form.get_rate"
            :key="index"
          > -->
        <!-- <el-row>
              <el-form-item label-width="160px" prop="" label="巡查时间 ">
                <el-col :span="6">
                  <el-time-picker
                    v-model="item.m_start_time"
                    type="time"
                    value-format="HH:mm:ss"
                    placeholder="开始日期"
                  >
                  </el-time-picker>
                </el-col>
                <el-col :span="6" class="ml20">
                  <el-time-picker
                    v-model="item.m_end_time"
                    type="time"
                    value-format="HH:mm:ss"
                    placeholder="结束日期"
                  >
                  </el-time-picker>
                </el-col>
              </el-form-item>
            </el-row> -->
        <!-- <el-row>
              <el-form-item label-width="160px" prop="" label="巡查时间 ">
                <el-col :span="6">
                  <el-select v-model="item.m_rate">
                    <el-option :value="1">1</el-option>
                    <el-option :value="2">2</el-option>
                    <el-option :value="3">3</el-option>
                    <el-option :value="4">4</el-option>
                    <el-option :value="5">5</el-option>
                  </el-select>
                </el-col>
              </el-form-item>
            </el-row> -->
        <!-- </div>
        </el-col> -->
      </el-row>
      <div class="f-right border-b">
        <div class="flex1">巡检检查内容</div>
      </div>
      <div class="flex ml20">
        <el-col :span="11">
          <h3 class="ml20 mt10">巡查标准</h3>
          <div class="ml20 flex1 mt20" style="padding-left: 50px">
            <el-tree
              :data="list"
              ref="tree1"
              show-checkbox
              @check-change="handleCheckChange"
              class="tree"
              node-key="id"
            >
            </el-tree>
          </div>
        </el-col>
        <!-- <el-col class="ml20" :span="11">
          <h3 class="ml20 mt10">本次巡查点标准</h3>

          <el-tree
            :data="list2"
            show-checkbox
            ref="tree2"
            class="tree"

          >
          </el-tree>
        </el-col> -->
      </div>
    </el-form>

    <div class="btn-box">
      <div class="l-btn" @click="onSubmit">保存</div>
      <div class="l-btn ml20" @click="$router.back()">返回</div>
    </div>
  </div>
</template>

<script>
// import {buildList} from './options'
// import {addCompany, editCompany} from "../../api/company";
// import {getArea} from "../../api/common";
import { getSafeList } from "../../api/safety";

export default {
  data() {
    return {
      id: this.$route.query.id || "",
      areaId: this.$route.query.areaId || "",
      cpNum: this.$route.query.cnum || "",

      form: {
        isTime: true,
        areaId: "",
        pointNum: "",
        pointName: "",
        pointAddr: "",
        nfcNum: "",
        companyNum: this.cpNum || "",
        remark: "",
        pointBasic: "",
        states: 1,

        // get_rate: [{ m_start_time: "", m_end_time: "", m_rate: "" }],
        inspectionList: [],
        roadNameDoorplate: "",
        builderName: "",
      },
      rules: {},
      CheckedKeys: [],
      props: {
        label: "111",
        children: "zo11nes",
      },
      list2: [],
      list: [],
      areaList: [],
    };
  },
  created() {
    if (this.areaId) {
      this.form.areaId = this.areaId;
    }
    console.log(this.cpNum);
    if (this.cpNum) {
      this.form.companyNum = this.cpNum;
      this.getList();
    }
  },
  mounted() {},

  methods: {
    save() {
      if (!this.form.inspectionList.length) {
        this.$message.warning("请至少选择一项检查项");
      } else {
        var url = "/inspection/wenwuInspectionPoint";
        if (this.id) {
          this.$put(url, this.form).then((res) => {
            // this.$message.success("操作成功");
            this.$message({
									message: "操作成功",
									type: 'success',
									duration: 700,
								});
            this.$router.back();
          });
        } else {
          this.$post(url, this.form).then((res) => {
            // this.$message.success("操作成功");
            this.$message({
									message: "操作成功",
									type: 'success',
									duration: 700,
								});
            this.$router.back();
          });
        }
      }
    },

    onSubmit() {
      this.$refs.tree1.getHalfCheckedKeys();
      var arr = this.$refs.tree1.getCheckedKeys().concat(this.$refs.tree1.getHalfCheckedKeys());
      this.form.inspectionList = arr;
      this.$refs.form.validate((valid) => {
        if (valid) {
          //this.save()
          this.save();
        } else {
          return false;
        }
      });

      //    this.$refs.form.validate((valid) => {
      //   if (valid) {
      //     this.save();
      //   } else {
      //     this.nowIndex = 0;
      //     return false;
      //   }
      // });

      // this.$refs.form.validate((valid) => {
      //               if (valid) {
      //                 this.save()
      //               } else {
      //                   console.log('error submit!!');
      //                   this.$message.warning('请填写必填项')
      //                   return false;
      //               }
      //           });
    },
    handleCheckChange(v, b) {
      // console.log(v.id);
      console.log(v,b,this.$refs.tree1.getCheckedKeys())
      this.CheckedKeys = this.$refs.tree1.getCheckedKeys();
      this.$refs.tree1.getCheckedKeys();
    },

    getList() {
      this.loading = true;

      this.$post("/inspectionWenWu/findtree")
        .then((res) => {
          var arr = [];
          res.data.list.map((item) => {
            var obj = { id: item.mid, label: item.checklist };
            if (item.childTreeList) {
              item.childTreeList.map((ite) => {
                var obj2 = { id: ite.mid, label: ite.checklist };
                obj.children ? obj.children.push(obj2) : (obj.children = [obj2]);
              });
            }
            arr.push(obj);
          });
          this.list = arr;
          // this.total = res.data.count
          // this.list = res.data.list
          // this.loading = false
          if (this.id) {
            this.$get(`/inspection/wenwuInspectionPoint/${this.id}`).then((res) => {
              this.form = res.data;
              // this.form.get_rate = res.list.rate;
              // this.form.get_item = res.list.item;
              var arr1 = [];
              var resArr = [];
              res.data.inspectionList.map((item) => {
                resArr.push(item);
              });
              //   console.log(resArr)
              // this.list.map((it) => {
              //   if (resArr.indexOf(it.id) > -1) {
              //     resArr.splice(resArr.indexOf(it.id), 1);
              //   }
              // });
              this.$refs.tree1.setCheckedKeys(resArr);
            });
          }
        })
        .catch((err) => {});
      this.$post("/patrol/selectareaWenWu", { c_company_num: this.cpNum }).then((res) => {
        this.areaList = res.data;
      });
    },
    //树的数组
  },
};
</script>

<style scoped>
.container-list {
  padding: 0 20px;
}
.tree {
  font-size: 18px;
}
</style>
